"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validatePortNumber = exports.portNumberSchema = void 0;
var zod = _interopRequireWildcard(require("zod"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const portNumberSchema = exports.portNumberSchema = zod.union([zod.number(), zod.string().transform(val => {
  const parsed = Number.parseInt(val, 10);
  if (Number.isNaN(parsed)) {
    return undefined;
  }
  return parsed;
})]);

/**
 * Validates the provided port number against the port number schema.
 *
 * @param portNumber - The port number string to validate.
 * @returns The validated port number if successful, otherwise undefined.
 */
const validatePortNumber = portNumber => {
  if (portNumber === undefined) {
    return undefined;
  }
  const result = portNumberSchema.safeParse(portNumber);
  if (result.success) {
    return result.data;
  }
  return undefined;
};
exports.validatePortNumber = validatePortNumber;
//# sourceMappingURL=validatePortNumber.js.map